import PropTypes from 'prop-types';
import { BeatLoader } from 'react-spinners';

const LoadingSpinner = ({ message, dark = false }) => (
  <div className="mx-auto flex w-3/5 max-w-[500px] flex-col items-center gap-6 p-6">
    <div>
      {message}
    </div>
    <BeatLoader
      color={`${dark ? '#828282' : 'var(--color-pj-primary-300)'}`}
      loading
      size={12}
      speedMultiplier={0.6}
    />
  </div>
);

LoadingSpinner.propTypes = {
  message: PropTypes.string.isRequired,
  dark: PropTypes.bool,
};

export default LoadingSpinner;
